"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function ComparisonCta() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#047857] text-white py-16 my-12">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold">
          {t("blog.shutters.ctaTitle")}
        </h2>
        <p className="mt-4 text-white/90 max-w-xl mx-auto">
          {t("blog.shutters.ctaBody")}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:7863774452"
            className="inline-block bg-white text-[#047857] font-bold px-8 py-3 rounded-lg hover:bg-[#fefce8] transition whitespace-nowrap"
          >
            {t("hood.callNow")}
          </a>
          <Link
            to="/legal-disclaimer/"
            className="inline-block border-2 border-white text-white font-bold px-8 py-3 rounded-lg hover:bg-white hover:text-[#047857] transition whitespace-nowrap"
          >
            {t("hood.getQuote")}
          </Link>
        </div>
      </div>
    </section>
  );
}